import superTable from '@/components/superTable';
export default {
  install: (Vue) => {
    Vue.component('super-table', superTable);
  },
};



// WEBPACK FOOTER //
// ./src/plugin/index.js